import Marionette from 'backbone.marionette';
import headlineItemViewTmpl from '../templates/headline_itemview.tpl';
export default Marionette.ItemView.extend({
  template: headlineItemViewTmpl,
  tagName: "div"
});